import React from "react";
import { COLOR_PALETTE } from "../../config/colorPalette";
import "./Styles/ColorPalettePicker.css";

/**
 * Fixed-palette color picker for admin product forms.
 * `selected`: array of palette color names currently chosen.
 * `onChange`: called with the updated array whenever a swatch is toggled.
 */
const ColorPalettePicker = ({ selected = [], onChange }) => {
  const toggle = (name) => {
    if (selected.includes(name)) {
      onChange(selected.filter((c) => c !== name));
    } else {
      onChange([...selected, name]);
    }
  };

  return (
    <div className="color-palette-picker">
      {COLOR_PALETTE.map(({ name, hex }) => {
        const isSelected = selected.includes(name);
        return (
          <button
            type="button"
            key={name}
            className={`color-palette-swatch${isSelected ? " selected" : ""}`}
            style={{ backgroundColor: hex }}
            onClick={() => toggle(name)}
            title={name}
            aria-pressed={isSelected}
            aria-label={name}
          >
            {isSelected && <span className="color-palette-check">✓</span>}
          </button>
        );
      })}
    </div>
  );
};

export default ColorPalettePicker;
